import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MemberSettingsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to new member dashboard with settings tab
    navigate('/member?tab=settings', { replace: true });
  }, [navigate]);

  return (
    <div className="settings-page">
      <div className="settings-page__redirecting">
        <p>重新導向至新的會員中心...</p>
      </div>
    </div>
  );
};

export default MemberSettingsPage;
